import type { CompanyUsersEntity } from '@/features/companyUsers/domain/entities/CompanyUsersEntity'
import type { MealItemSelectionEntity } from './MealItemSelectionEntity'

export class PostMealItemEntity {
  mealId?: string
  user?: CompanyUsersEntity
  itemId?: number
  companyId?: number
  note?: string | null
  selections?: Array<MealItemSelectionEntity> | null
  quantity?: number
}
